import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// styles
import { UnstyledListItemStyled } from "core/SiteHeader/styles.js";
import colors, { focusStyles } from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { regular as regularFontWeight } from "core/fontStyles";

export const linkStyles = ($isDarkMode = false) => {
    return css`
        ${regularFontWeight}
        display: inline-block;
        text-decoration: none;

        line-height: 24px;
        color: ${$isDarkMode ? colors.primary.diamond : colors.secondary.orca};
        font-size: ${convertPxToRem(15)};
        border-bottom: solid 1px transparent;
        transition: opacity 0.5s ease;

        /* Overriding Legacy Styles */
        &:visited {
            color: ${$isDarkMode ? colors.primary.diamond : colors.secondary.orca};
            text-decoration: none;
            transition: opacity 0.5s ease;
        }

        &:hover {
            border-bottom-color: ${$isDarkMode
                ? colors.primary.diamond
                : colors.secondary.orca};
        }

        ${focusStyles}
    `;
};

const LinkListItemStyled = styled(UnstyledListItemStyled)`
    margin: 0rem ${convertPxToRem(8)};
`;

export const AnchorStyled = styled.a`
    ${({ $isDarkMode }) => {
        return css`
            ${linkStyles($isDarkMode)}
        `;
    }};
`;

// component
export const Link = ({
    className,
    link,
    onFocus,
    isDisabled = false,
    onMouseDown,
    onClick,
}) => {
    const { isDarkMode } = useSiteHeader();

    return (
        <LinkListItemStyled className={className}>
            <AnchorStyled
                href={link.href}
                target={link?.target || "_self"}
                $isDarkMode={isDarkMode}
                onFocus={onFocus}
                tabIndex={isDisabled ? -1 : 0}
                aria-disabled={isDisabled}
                onMouseDown={onMouseDown}
                onClick={onClick}
            >
                {link.name}
            </AnchorStyled>
        </LinkListItemStyled>
    );
};

export default Link;

// prop-types
Link.propTypes = {
    className: PropTypes.string,
    link: PropTypes.object.isRequired,
    onFocus: PropTypes.func,
    isDisabled: PropTypes.bool,
    onMouseDown: PropTypes.func,
    onClick: PropTypes.func,
};
